/** 表格链接按钮选择文本时，阻止按钮把拖拽结束误判为一次导航点击。 */
export function enableTableLinkTextSelection(): () => void {
    const selector = ".ant-table-tbody :is(.ant-btn-link, .ant-btn-variant-link)";
    let dragStart: { element: Element; x: number; y: number } | null = null;

    /** 只记录表格链接上的鼠标起点，键盘激活和普通按钮点击保持原行为。 */
    const onPointerDown = (event: PointerEvent) => {
        const element = event.target instanceof Element ? event.target.closest(selector) : null;
        dragStart = event.pointerType === "mouse" && event.button === 0 && element
            ? { element, x: event.clientX, y: event.clientY }
            : null;
    };

    /** 选区确实来自当前链接且发生拖动时，拦截浏览器合成的 click。 */
    const onClick = (event: MouseEvent) => {
        const start = dragStart;
        dragStart = null;
        if (!start || !(event.target instanceof Node) || !start.element.contains(event.target)) return;

        const selection = document.getSelection();
        const moved = Math.hypot(event.clientX - start.x, event.clientY - start.y) > 3;
        if (!moved || !selection || selection.isCollapsed || !selection.toString().trim()) return;
        if (!selection.anchorNode || !start.element.contains(selection.anchorNode)) return;

        event.preventDefault();
        event.stopPropagation();
    };

    document.addEventListener("pointerdown", onPointerDown, true);
    document.addEventListener("click", onClick, true);
    return () => {
        document.removeEventListener("pointerdown", onPointerDown, true);
        document.removeEventListener("click", onClick, true);
    };
}
